import"../defaults.js";import{getRegionSpacing as e}from"../get-section-padding.js";import"../../types.js";import{get as t}from"lodash";function n(){return`
    .html-email-body-section-footer > table > tbody > tr > td {
      padding-bottom: 10px!important;
    }
  `}function r({css:t}){let n=e(t,`footer`).padding.top;return n>24&&(n=24),`
    .html-email-body-section-footer > table > tbody > tr > td {
      padding-top: ${n}px!important;
    }

    .html-emails-footer-section > table > tbody > tr > td {
      padding: 0!important;
    }

    .footer-top-spacer {
      padding: 0!important;
    }
  `}function i({css:e,sections:n}){let r=n.find(({type:e})=>e===`footer`),i=r?.footer?.separatorColor||r?.separatorColor||t(e,`so-global-footer-separator.borderColor`)||`#000000`;return`
    .html-emails-footer-section.show-border-right > table {
      border-right: 1px solid ${i} !important;
    }

    .html-emails-footer-section.show-border-left > table {
      border-left: 1px solid ${i} !important;
    }

    .html-emails-footer-section.bigger-column-height > table {
      height: 67px!important;
    }
  `}function a(){return`
    .html-emails-footer-divider {
      display: none;
    }
  `}function o(){return`
    .html-emails-footer-divider {
      display: block !important;
      padding-bottom: 18px!important;
      padding-top: 18px!important;
    }
    .html-emails-footer-divider > * {
      width: 70px!important;
      border-width: 1px!important;
    }
    .html-emails-footer-site-with-mobile-divider {
      padding-top:0px!important;
      padding-bottom:0px!important;
    }

    .html-emails-footer-business-details-with-mobile-divider {
      padding-bottom:0px!important;
    }
  `}function s(){return`
    .html-emails-footer-mobile-place-section > table > tbody > tr > td {
      padding-top: 8px!important;
      padding-bottom: 10px!important;
    }

    .html-emails-footer-mobile-place-section-no-divider > table > tbody > tr > td {
      padding-top: 20px!important;
      padding-bottom: 10px!important;
    }

    .html-emails-footer-mobile-place-divider {
      padding-top: 0px!important;
      padding-bottom: 18px!important;
    }
    .html-emails-footer-mobile-place-divider > * {
      width: 70px!important;
    }
    .html-emails-footer-mobile-place-text {
      padding: 0 20px!important;
    }
    .html-emails-footer-mobile-place-cta {
      padding: 10px 20px 0!important;
    }
  `}function c(){return{smScreen:[n,o,r,s],lgScreen:i,all:a}}export{a as getFooterDividerCss,o as getFooterDividerSmCss,c as getFooterSectionStyle,i as getFooterSeparatorForLargeScreensCss,n as getFooterTweaksForSmallScreens,r as getFooterTweaksInSimulatorForSmallScreens,s as getMobilePlaceSmCss};
//# sourceMappingURL=get-footer-section-style.js.map